import React from 'react';
// Core
import clsx from 'clsx';
import { Switch } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

// Routing
import { PrivateRoute } from 'src/routing/PrivateRoute';

// UI
import { makeStyles } from '@material-ui/core/styles';
import { useCommonStyles } from 'src/materialConfig/commonStyles';

// Components
import { DesktopMenuList } from './menus/DesktopMenuList';
import { MobileMenuList } from './menus/MobileMenuList';

// Instruments
import { useDeviceSizeType } from 'src/utils/hooks/useDeviceType';
import { userRoutes } from '../../../routing/AccountRoutes';

const useStyles = makeStyles((theme) => ({
  layout: {
    // marginTop: '20px',
    // margin: '0px',
    display: 'grid',
    gridTemplateColumns: '279px 1fr',
    // boxShadow: '0px 8px 30px rgba(108, 108, 108, 0.15)',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '100%',
      boxShadow: 'unset',
      borderRadius: 0,
    },
  },
  layout__menu: {
    [theme.breakpoints.down('md')]: {
      marginBottom: '10px',
    },
  },
  layout__mobileMenuWrapper: {
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    padding: '0 20px',
  },
}));

export const UserLayout: React.FC = () => {
  const { isMobile } = useDeviceSizeType();
  const classes = useStyles();
  const { user } = useSelector((state: RootState) => state.auth);
  const { pathname } = useLocation();
  const commonClasses = useCommonStyles();

  const currentMenu = isMobile ? (
    <div
      className={clsx(
        commonClasses.container,
        classes.layout__mobileMenuWrapper,
      )}
    >
      <MobileMenuList user={user!} currentPath={pathname} />
    </div>
  ) : (
    <DesktopMenuList
      user={user!}
      className={classes.layout__menu}
      currentPath={pathname}
    />
  );

  return (
    <div className={clsx(classes.layout, !isMobile && commonClasses.container)}>
      {currentMenu}
      <Switch>
        {userRoutes.map((route) => {
          return <PrivateRoute key={route.path} exact {...route} />;
        })}
      </Switch>
    </div>
  );
};
